import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserAuthService } from '../service/user-auth.service';
import { hasKey } from '../util/object.util';

@Component({
  selector: 'app-change-email-verify',
  templateUrl: './change-email-verify.component.html',
  styleUrls: ['./change-email-verify.component.scss']
})
export class ChangeEmailVerifyComponent implements OnInit {

  public verifyingBlock = true;
  public errorVerifyingBlock = false;
  public successVerifyingBlock = false;

  constructor(
    private __userAuthService: UserAuthService,
    private __activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.verifyEmailChange();
  }

  verifyEmailChange(): void {
    this.__activatedRoute.queryParams.subscribe(queryParams => {
      if (!hasKey(queryParams, 'token')) {
        this.verifyingBlock = false;
        this.errorVerifyingBlock = true;
        return;
      }

      const token = String(queryParams.token);

      this.__userAuthService.verifyEmailChange(token).subscribe({
        next: () => {
          this.verifyingBlock = false;
          this.successVerifyingBlock = true;
          setTimeout(() => this.__userAuthService.logout(), 2000);
        },
        error: () => {
          this.verifyingBlock = false;
          this.errorVerifyingBlock = true;
        }
      });
    });
  }
}
